import React from 'react';
import { useEffect } from 'react';

const ProductTitle = ({productname,baseLink, basePath, currentPath, grouping, subLink, subPath,currentProduct}) => {
  const initializeYotpoWidget = () => {
    if (window.Yotpo && window.Yotpo.ready) {
      window.Yotpo.ready(() => {
        console.log("Initializing Yotpo widgets");
        window.yotpoWidgetsContainer.initWidgets();
      });
    } else {
      setTimeout(initializeYotpoWidget, 1000); // Retry after 1 second
    }
  };
  
  useEffect(() => {
    if (currentProduct) {
      const wrapper = document.getElementById('yotpoReviewsWidget');
      if (wrapper) {
        wrapper.innerHTML = `
          <div className="yotpo-widget-instance" 
            data-yotpo-instance-id="1014586" 
            data-yotpo-product-id="${currentProduct.id}">
          </div>`;
        initializeYotpoWidget();
      }
    }
  }, [currentProduct]);
  
  
  
  return (
    <>
    <div className={`breadcrumb ${grouping}`}>
      <ul className="breadcrumb__list" role="navigation" aria-label="breadcrumbs" itemScope itemType="https://schema.org/BreadcrumbList">
        {/* Base breadcrumb */}
        <li className="breadcrumb__item" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <a href={baseLink} className="type type--medium" itemProp="item">
            <span itemProp="name">{basePath}</span>
          </a>
          <meta itemProp="position" content="1" />
        </li>

        {/* Sub Path breadcrumb (conditional) */}
        {subPath && (
          <li className="breadcrumb__item" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <a href={subLink} className="type type--medium" itemProp="item">
              <span itemProp="name">{subPath}</span>
            </a>
            <meta itemProp="position" content="2" />
          </li>
        )}

        {/* Current Path breadcrumb */}
        <li className="breadcrumb__item type type--medium" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <span itemProp="name">{currentPath}</span>
          <meta itemProp="position" content={subPath ? '3' : '2'} />
        </li>
      </ul>
    </div>
    <h1 className='medium product_title'>{productname}</h1>
    <div id='yotpoReviewsWidget'>
    <div className="yotpo-widget-instance" data-yotpo-instance-id="1014586" data-yotpo-product-id={currentProduct.id}></div>
    </div>
    </>
  );
};

export default ProductTitle;